<template>
  <div>
    <div class="banner">
    <img src="https://bank.giftoceanmall.com/aa4f4202608142234344161.png" alt="">
  </div>
  <div class="goodsList">
    <div class="xjdq">
      <div class="title xjdqtit">
      </div>
      <div class="goods">
        <div v-for="item in xjdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ getFenqiText(item.fenqi) }}</span>
          </div>
          <img :src="item.img" :alt="item.name">
          <div class="goods-info">
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shdq">
      <div class="title shdqtit">
      </div>
      <div class="goods">
        <div v-for="item in shdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ getFenqiText(item.fenqi) }}</span>
          </div>
          <img :src="item.img" :alt="item.name">
          <div class="goods-info">
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cfdq">
      <div class="title cfdqtit">
      </div>
      <div class="goods">
        <div v-for="item in cfdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ getFenqiText(item.fenqi) }}</span>
          </div>
          <img :src="item.img" :alt="item.name">
          <div class="goods-info">
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ghdq">
      <div class="title ghdqtit">
      </div>
      <div class="goods">
        <div v-for="item in ghdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ getFenqiText(item.fenqi) }}</span>
          </div>
          <img :src="item.img" :alt="item.name">
          <div class="goods-info">
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="djd">
      <div class="title djdtit">
      </div>
      <div class="goods">
        <div v-for="item in djd" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ getFenqiText(item.fenqi) }}</span>
          </div>
          <img :src="item.img" :alt="item.name">
          <div class="goods-info">
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
</template>

<script>
import { goShopDetail } from "@libs/order";

export default {
  name: "ElectricalActivities",
  data() {
    return {
      title: "海礼网品质家电专场",
      xjdq: [
        {
          id: 7,
          name: '海尔空气循环扇HFX-Y2351',
          tit: '海尔大品牌遥控循环扇 价格远低于监控市场价 价拼拼多多',
          img: 'https://bank.giftoceanmall.com/d73e920260630155715896.png',
          oldprice: '299',
          price: '199',
          fenqi: 3,
          brand: '海尔',
          category: '循环扇',
          discount: '直降80',
          recommend: '海尔大品牌遥控循环扇价格远低于监控市场价 价拼拼多多',
          onlinePrice: '329'
          
        },
        {
          id: 247,
          name: '海信循环扇机械款FXJ-AN1803',
          tit: '超高性价比 百元价位循环扇',
          img: 'https://bank.giftoceanmall.com/65c60202606121522116224.jpg',
          oldprice: '149',
          price: '129',
          fenqi: 3,
          brand: '海信',
          category: '循环扇',
          discount: '直降20',
          recommend: '超高性价比 百元价位循环扇',
          onlinePrice: '149'
        },
        {
          id: 248,
          name: '美的落地扇FSA25UB',
          tit: '美的大牌百元落地扇',
          img: 'https://bank.giftoceanmall.com/2819c202606121525415003.jpg',
          oldprice: '169',
          price: '109',
          fenqi: 3,
          brand: '美的',
          category: '落地扇',
          discount: '直降60',
          recommend: '美的大牌百元落地扇',
          onlinePrice: '259'
        },
        {
          id: 175,
          name: '美的桌面风扇GAF18AD',
          tit: '电商百万销量大爆款 美的大品牌',
          img: 'https://bank.giftoceanmall.com/1fb89202606021650113997.jpg',
          oldprice: '138',
          price: '118',
          fenqi: 3,
          brand: '美的',
          category: '桌面风扇',
          discount: '直降11',
          recommend: '电商百万销量大爆款 美的大品牌',
          onlinePrice: '144'
        },
        {
          id: 41,
          name: '海尔电风扇遥控款FSY3005',
          tit: '海尔落地扇',
          img: 'https://www.giftoceanmall.com/uploads/attach/2025/06/20250611/3dc739bc609c0f106168548b29bcd4a1.jpg',
          oldprice: '169',
          price: '139',
          fenqi: 3,
          brand: '海尔',
          category: '落地扇',
          discount: '直降20',
          recommend: '',
          onlinePrice: '189'
        },
        {
          id: 42,
          name: '海尔落地扇FSJ3510',
          tit: '海尔落地扇',
          img: 'https://bank.giftoceanmall.com/6a8ff202606021636439340.jpg',
          oldprice: '169',
          price: '139',
          fenqi: 3,
          brand: '海尔',
          category: '落地扇',
          discount: '直降20',
          recommend: '',
          onlinePrice: '189'
        },
        {
          id: 165,
          name: '美的落地扇SDJ35FL',
          tit: '海尔落地扇',
          img: 'https://bank.giftoceanmall.com/4b995202605091547233562.jpg',
          oldprice: '469',
          price: '369',
          fenqi: 3,
          brand: '海尔',
          category: '落地扇',
          discount: '直降5',
          recommend: '',
          onlinePrice: '134'
        },
        {
          id: 167,
          name: '美的无叶塔扇AAI12PV',
          tit: '海尔落地扇',
          img: 'https://bank.giftoceanmall.com/44f8e202605091600314462.jpg',
          oldprice: '769',
          price: '669',
          fenqi: 3,
          brand: '海尔',
          category: '落地扇',
          discount: '直降5',
          recommend: '',
          onlinePrice: '134'
        },
        {
          id: 168,
          name: '美的冷风塔扇ADJ10BF',
          tit: '海尔落地扇',
          img: 'https://bank.giftoceanmall.com/1cf0920260509160839333.jpg',
          oldprice: '539',
          price: '469',
          fenqi: 3,
          brand: '海尔',
          category: '落地扇',
          discount: '直降5',
          recommend: '',
          onlinePrice: '134'
        }

      ],
      shdq:[
        {
          id: 250,
          name: '海尔榨汁机HBL-P06B3F',
          tit: '海尔榨汁机单品全网最低价',
          img: 'https://bank.giftoceanmall.com/08854202606121532375403.jpg',
          oldprice: '129',
          price: '59',
          fenqi: 3,
          brand: '海尔',
          category: '榨汁机',
          discount: '直降70',
          recommend: '海尔榨汁机单品全网最低价',
          onlinePrice: '199'
        },
        {
          id: 251,
          name: '海尔挂烫机HY-MC1209F',
          tit: '海尔电商热商品 单品全网最低价',
          img: 'https://bank.giftoceanmall.com/7d36e202606121535311614.jpg',
          oldprice: '129',
          price: '89',
          fenqi: 3,
          brand: '海尔',
          category: '挂烫机',
          discount: '直降40',
          recommend: '海尔电商热商品 单品全网最低价',
          onlinePrice: '233'
        },
        {
          id: 252,
          name: '海尔吸尘器HZ-W4A',
          tit: '',
          img: 'https://bank.giftoceanmall.com/351aa202606121539046180.jpg',
          oldprice: '399',
          price: '349',
          fenqi: 3,
          brand: '海尔',
          category: '吸尘器',
          discount: '直降50',
          recommend: '性价比高',
          onlinePrice: '1099'
        },
        {
          id: 164,
          name: '海尔基站吸尘器HSC-SA301D',
          tit: '海尔抖音大爆款 单品全网最低价',
          img: 'https://bank.giftoceanmall.com/60b61202606301556314513.png',
          oldprice: '999',
          price: '899',
          fenqi: 12,
          brand: '海尔',
          category: '基站吸尘器',
          discount: '直降100',
          recommend: '海尔抖音大爆款 单品全网最低价',
          onlinePrice: '1130'
        },
        {
          id: 253,
          name: '美的养生壶MK-Y15X-J',
          tit: '美的大品牌 该价位高性价比',
          img: 'https://bank.giftoceanmall.com/c003220260612154144605.jpg',
          oldprice: '98',
          price: '78',
          fenqi: 3,
          brand: '美的',
          category: '养生壶',
          discount: '直降20',
          recommend: '美的大品牌 该价位高性价比',
          onlinePrice: '98'
        },
        {
          id: 53,
          name: '海尔手持除螨仪HZ-C703R',
          tit: '',
          img: 'https://bank.giftoceanmall.com/67af4202606021631247958.jpg',
          oldprice: '279',
          price: '179',
          fenqi: 3,
          brand: '海尔',
          category: '除螨仪',
          discount: '直降100',
          recommend: '性价比高',
          onlinePrice: '799'
        },
        {
          id: 117,
          name: '海尔电保温壶盖BWH-H18BE',
          tit: '',
          img: 'https://bank.giftoceanmall.com/1b102202606021630477986.jpg',
          oldprice: '169',
          price: '139',
          fenqi: 3,
          brand: '海尔',
          category: '保温壶',
          discount: '直降30',
          recommend: '领先品牌',
          onlinePrice: '169'
        },
        {
          id: 116,
          name: '海尔恒温水壶盖BWH-P05W1',
          tit: '',
          img: 'https://www.giftoceanmall.com/uploads/attach/2025/11/20251124/13e0231f2bab0c7b5d8d7dc778ba9c6c.jpg',
          oldprice: '397',
          price: '337',
          fenqi: 3,
          brand: '海尔',
          category: '恒温水壶',
          discount: '直降60',
          recommend: '电热水杯颜值款',
          onlinePrice: '373'
        }
      ],
      cfdq:[
        {
          id: 3,
          name: '海尔空气炸锅HA-JL30D',
          tit: '海尔大品牌 单品全网最低价',
          img: 'https://bank.giftoceanmall.com/7353d202606021640244609.jpg',
          oldprice: '189',
          price: '159',
          fenqi: 3,
          brand: '海尔',
          category: '空气炸锅',
          discount: '直降30',
          recommend: '海尔大品牌 单品全网最低价',
          onlinePrice: '699'
        },
        {
          id: 54,
          name: '海尔电磁炉SP21-CK36',
          tit: '',
          img: 'https://bank.giftoceanmall.com/092b6202606021632551328.jpg',
          oldprice: '179',
          price: '159',
          fenqi: 3,
          brand: '海尔',
          category: '电磁炉',
          discount: '直降20',
          recommend: '性价比高',
          onlinePrice: '499'
        },
        {
          id: 254,
          name: '美的电压力锅MY-E523',
          tit: '美的电商百万销量大爆款 全网最低价',
          img: 'https://bank.giftoceanmall.com/aedd720260612155118910.jpg',
          oldprice: '229',
          price: '199',
          fenqi: 3,
          brand: '美的',
          category: '电压力锅',
          discount: '直降30',
          recommend: '美的电商百万销量大爆款 全网最低价',
          onlinePrice: '239'
        },
        {
          id: 217,
          name: '美的电饭煲MB-HC3032',
          tit: '美的大品牌 电商热销品 全网最低价',
          img: 'https://bank.giftoceanmall.com/abe7f20260602165412526.jpg',
          oldprice: '299',
          price: '269',
          fenqi: 3,
          brand: '美的',
          category: '电饭煲',
          discount: '直降30',
          recommend: '美的大品牌 电商热销品 全网最低价',
          onlinePrice: '399'
        },
        {
          id: 158,
          name: '海尔家用多功能锅 DYG-MX4501A ',
          tit: '海尔大品牌 单品全网最低价',
          img: 'https://bank.giftoceanmall.com/b4e6e202606021634204403.jpg',
          oldprice: '399',
          price: '299',
          fenqi: 3,
          brand: '海尔',
          category: '多功能锅',
          discount: '直降100',
          recommend: '海尔大品牌 单品全网最低价',
          onlinePrice: '699'
        },
        {
          id: 103,
          name: '海尔 电饼铛HSMC-ET30ZDA',
          tit: '',
          img: 'https://www.giftoceanmall.com/uploads/attach/2025/11/20251105/3bee604e0979a0a6e436c909da476d44.png',
          oldprice: '199',
          price: '149',
          fenqi: 3,
          brand: '海尔',
          category: '电饼铛',
          discount: '直降50',
          recommend: '性价比高',
          onlinePrice: '399'
        },
        {
          id: 212,
          name: '美的赤炎臻香低糖电饭煲MB-SFB3021H',
          tit: '',
          img: 'https://bank.giftoceanmall.com/026c5202606021656512547.jpg',
          oldprice: '1399',
          price: '1099',
          fenqi: 3,
          brand: '美的',
          category: '电饭煲',
          discount: '直降300',
          recommend: '美的电饭煲系列再添德系品质珐琅铸铁般的球形双内胆、特色微压沸腾新',
          onlinePrice: '1565'
        },
        {
          id: 215,
          name: '美的电饭煲IH加热香甜精铁釜MB-CFB5099H',
          tit: '',
          img: 'https://bank.giftoceanmall.com/54385202605261137111678.jpg',
          oldprice: '599',
          price: '549',
          fenqi: 3,
          brand: '美的',
          category: '电饭煲',
          discount: '直降50',
          recommend: '电饭煲热销型号',
          onlinePrice: '599'
        },
        {
          id: 206,
          name: '苏泊尔空气炸锅KJ60D76',
          tit: '',
          img: 'https://bank.giftoceanmall.com/2e2bd202605131149074280.jpg',
          oldprice: '449',
          price: '349',
          fenqi: 3,
          brand: '苏泊尔',
          category: '空气炸锅',
          discount: '直降100',
          recommend: '大容量全性能设计',
          onlinePrice: '399'
        }
      ],
      ghdq:[
        {
          id: 140,
          name: '海尔电动牙刷HTA2-HYB',
          tit: '海尔大品牌 全网最低价 超高性价比单品',
          img: 'https://bank.giftoceanmall.com/54246202606301555277711.png',
          oldprice: '79',
          price: '49',
          fenqi: 3,
          brand: '海尔',
          category: '电动牙刷',
          discount: '直降30',
          recommend: '海尔大品牌 全网最低价 超高性价比单品',
          onlinePrice: '499'
        },
        {
          id: 156,
          name: '罗莱健康揉腹器LUOLAI-CLD100RF',
          tit: '',
          img: 'https://bank.giftoceanmall.com/7b00e202606021647525209.jpg',
          oldprice: '169',
          price: '139',
          fenqi: 3,
          brand: '罗莱健康',
          category: '按摩器',
          discount: '直降30',
          recommend: '送礼自用佳品',
          onlinePrice: '1399'
        },
        {
          id: 38,
          name: '海尔颈椎按摩器X602Z',
          tit: '',
          img: 'https://bank.giftoceanmall.com/65cbd202606301556049394.png',
          oldprice: '169',
          price: '149',
          fenqi: 3,
          brand: '海尔',
          category: '按摩器',
          discount: '直降20',
          recommend: '送礼自用首选',
          onlinePrice: '999'
        },
        {
          id: 15,
          name: '海尔颈椎按摩器HHZ-Y606H-Pro',
          tit: '',
          img: 'https://bank.giftoceanmall.com/b3e2a202606021646398328.jpg',
          oldprice: '179',
          price: '159',
          fenqi: 3,
          brand: '海尔',
          category: '按摩器',
          discount: '直降20',
          recommend: '专业颈椎按摩',
          onlinePrice: '199'
        },
        {
          id: 141,
          name: '海尔剃须刀HZ71218',
          tit: '',
          img: 'https://bank.giftoceanmall.com/7e4ba202606021645431634.jpg',
          oldprice: '99',
          price: '59',
          fenqi: 3,
          brand: '海尔',
          category: '剃须刀',
          discount: '直降40',
          recommend: '专为男士定制的胡须修剪 超薄超轻',
          onlinePrice: '299'
        },
        {
          id: 11,
          name: '海尔吹风机FTA71灵雀紫',
          tit: '',
          img: 'https://www.giftoceanmall.com/uploads/attach/2025/06/20250604/662b2283defb84b24aae57be79b29eef.jpg',
          oldprice: '199',
          price: '179',
          fenqi: 3,
          brand: '海尔',
          category: '吹风机',
          discount: '直降20',
          recommend: '柔烘倍护 生发',
          onlinePrice: '189'
        }
      ],
      djd:[
        {
          id: 255,
          name: '海尔冰箱BCD-517WLHSSEDSD',
          tit: '',
          img: 'https://bank.giftoceanmall.com/263bb202606121554313263.jpg',
          oldprice: '2699',
          price: '2499',
          fenqi: 3,
          brand: '海尔',
          category: '冰箱',
          discount: '直降200',
          recommend: '',
          onlinePrice: '2950'
        },
        {
          id: 19,
          name: '海尔洗衣机XQG100-50GW',
          tit: '',
          img: 'https://bank.giftoceanmall.com/d1253202606021642035648.jpg',
          oldprice: '1999',
          price: '1799',
          fenqi: 12,
          brand: '海尔',
          category: '洗衣机',
          discount: '直降200',
          recommend: '',
          onlinePrice: '2363'
        },
        {
          id: 20,
          name: '海尔洗衣机XQG80-L939W',
          tit: '',
          img: 'https://bank.giftoceanmall.com/c9bfb202606021641258418.jpg',
          oldprice: '1999',
          price: '1699',
          fenqi: 12,
          brand: '海尔',
          category: '洗衣机',
          discount: '直降300',
          recommend: '',
          onlinePrice: '2349'
        },
        // {
        //   id: 46,
        //   name: '海尔空调KFR-35GW/A0X1A181',
        //   tit: '',
        //   img: 'https://bank.giftoceanmall.com/2d5fc20260630155446672.png',
        //   oldprice: '1999',
        //   price: '2499',
        //   fenqi: 12,
        //   brand: '海尔',
        //   category: '空调',
        //   discount: '直降200',
        //   recommend: '',
        //   onlinePrice: '2148'
        // },
       
      ]
    };
  },
  methods: {
    goDetail(id) {
      console.log(id);
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
    getFenqiText(fenqi) {
      if (!fenqi) return '';
      // 如果是数字，直接作为期数
      if (typeof fenqi === 'number') {
        return fenqi + '期免息';
      }
      // 如果是字符串，提取期数
      const match = String(fenqi).match(/(\d+)期/);
      if (match) {
        return match[1] + '期免息';
      }
      return '';
    },
  },
}
</script>
<style scoped lang="scss">
.banner {
  width: 100%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.15rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.goodsList {
  width: 96%;
  margin: 0 auto;
  .xjdq, .shdq, .cfdq, .ghdq, .djd {
    width: 100%;
    height: auto;
    margin-bottom: 0.2rem;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    
    .xjdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/ca03e202606291956197546.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .shdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/b9033202606301116096744.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .cfdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/6c5d420260630111621539.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .ghdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/7e0ba20260630111636929.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .djdtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/5f793202606301116532675.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .title{
      background-repeat: no-repeat;
    }

    
    .goods {
      display: flex;
      flex-wrap: wrap;
      padding: 0.1rem;
      
      .goods-item {
        width: calc(33.333% - 0.07rem);
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
        
        &:nth-child(3n) {
          margin-right: 0;
        }
        
        position: relative;
        
        .fenqi-tag {
          position: absolute;
          top: 0;
          right: 0;
          background: linear-gradient(135deg, #ff4444 0%, #ff0000 100%);
          color: #fff;
          font-size: 0.2rem;
          padding: 0.05rem 0.15rem;
          border-radius: 0 0.1rem 0 0.15rem;
          z-index: 10;
          font-weight: bold;
          
          span {
            display: block;
            white-space: nowrap;
          }
        }
        
        img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 0.1rem 0.1rem 0 0;
        }
        
        .goods-info {
          padding: 0.1rem;
          
          .goods-name {
            font-size: 0.24rem;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 0.08rem;
            line-height: 1.4;
          }
          
          .goods-price {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            
            .fenqi {
              font-size: 0.22rem;
              color: #999;
            }
            
            .price {
              font-size: 0.32rem;
              color: #ff4444;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
